(function () {
  'use strict';

  // Galeria de produto: troca a imagem principal ao clicar nas miniaturas
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-product-main-image]');
    if (main) {
      main.src = thumb.getAttribute('data-full') || thumb.src;
      main.alt = thumb.alt;
    }
  });

  // Seletores de variante (opções em botões)
  var forms = document.querySelectorAll('[data-product-form]');
  forms.forEach(function (form) {
    var variantInput = form.querySelector('[data-variant-id]');
    var variantsData = form.querySelector('[data-variants-json]');
    if (!variantsData) return;
    var variants = JSON.parse(variantsData.textContent);
    var selected = {};

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = btn.getAttribute('data-option-position');
        var value = btn.getAttribute('data-option-value');
        selected[position] = value;

        form
          .querySelectorAll('[data-option-position="' + position + '"]')
          .forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');

        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return selected[i + 1] === undefined || selected[i + 1] === opt;
          }) && Object.keys(selected).length === v.options.length;
        });

        if (match && variantInput) {
          variantInput.value = match.id;
          var priceEl = form.querySelector('[data-product-price]');
          if (priceEl && match.price) {
            priceEl.textContent = formatMoney(match.price);
          }
        }
      });
    });
  });

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
})();
